const PrivacyPolicy = () => {
    return (
      <div  style={{ margin :'40px 0' }}>
        <h3>1. Information We Collect</h3>
        <p>
          We collect information that you provide directly to us, such as when you create an account, fill out forms, or interact with our services.
        </p>
        <h3>2. Use of Information</h3>
        <p>
          We may use the information we collect to operate, maintain, and improve our services, to communicate with you, and to personalize your experience.
        </p>
        <h3>3. Sharing of Information</h3>
        <p>
          We do not share your personal information with third parties without your consent, except in the circumstances described in our Privacy Policy.
        </p>
        <h3>4. Security</h3>
        <p>
          We take reasonable measures to help protect information about you from loss, theft, misuse, and unauthorized access, disclosure, alteration, and destruction.
        </p>
      </div>
    );
  };
  
  export default PrivacyPolicy;
  